const EmployList = [];

function importAll(r) {
    // eslint-disable-next-line no-return-assign
    r.keys().forEach((s, i) => EmployList[i] = r(s));
}

importAll(require.context('./assets/other/', true));

export default EmployList;
